(function($, Drupal) {
  Drupal.behaviors.expand_properties = {
    attach: function(context, settings) {
      $('.show-all').once('toggle-properties').on('click', function() {
        $('#property-wrap').slideToggle(300);
      });

      let $type = '';
      let $section_start;
      $('.field--name-field-losses-policy > .field__item').each(function() {
        let $current_type = $(this).find('.field--name-field-losses-policy-type').first().text();
        if ($current_type !== $type) {
          $type = $current_type;
          $section_start = $(this).closest('.field__item');
          $section_start.addClass('section-start');
        }
      });

      // wrapp all items including the intial 'section-start' class until next 'section-start' class
      $('.field--name-field-losses-policy .field__item').each(function() {
        if ($(this).hasClass('section-start')) {
          $(this).nextUntil('.section-start').addBack().wrapAll('<div class="section"></div>');
        }
      });

      // Add up claims and inject into table header
      $('.field--name-field-losses-policy .accordion-content').once('calculate-claims').each(function() {
        let $total = 0;
        let $total_claims = 0;
        $(this).find('td > .field--name-field-total-per-claim .field__item').once('add-claim').each(function() {
          $total += parseInt($(this).attr('content'));
          $total_claims++;
        });

        if ($total_claims === 0) {
          $total = 'Unknown (loss runs not received)';
        }
        else {
          $total = $total_claims + ' Claims totaling $' + $total.toLocaleString();
        }

        $(this).parent().find('.claims-total').text($total);
      });

      // Losses Modal
      $('.losses-modal-trigger').once('losses-modal-trigger').on('click', function() {
        $(this).toggleClass('open');

        let $as_of_date = $(this).closest('.document-library').find('.as-of-date').text();

        if ($as_of_date) {
          $(this).next('.losses-modal').find('.as-of-placeholder').text($as_of_date);
        }
      });

      $('.close-losses-modal').once('close-losses-modal').on('click', function() {
        $('.losses-modal-trigger').removeClass('open');
      });

      $(document).on('click', function(e) {
        if (!$(e.target).closest('.losses-modal-content').length && !$(e.target).closest('.losses-modal-trigger').length) {
          $('.losses-modal-trigger').removeClass('open');
        }
      });
    }
  };
})(jQuery, Drupal);
